(() => {
	"use strict";
	var e, t = {
			129: (e, t, a) => {
				var n = a(7294),
					i = a(3935),
					o = a(4486),
					s = a.n(o);
				const r = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || (e => {
						setTimeout(e, 16.666666666666668)
					}),
					l = function() {
						this.isListening = !1, this.listeners = [], this.onScroll = this.onScroll.bind(this), this.onScroll = (e => {
							let t = !1;
							const a = () => {
								e(), t = !1
							};
							return () => {
								t || (t = !0, r(a))
							}
						})(this.onScroll), this.manageWindowEventListener()
					};
				l.prototype.destroy = function() {
					this.isListening = !1, this.listeners = [], window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onScroll)
				}, l.prototype.listen = function(e) {
					this.listeners.indexOf(e) > -1 || (this.listeners.push(e), this.manageWindowEventListener())
				}, l.prototype.unlisten = function(e) {
					let t = this.listeners.indexOf(e);
					t > -1 && this.listeners.splice(t, 1), this.manageWindowEventListener()
				}, l.prototype.onScroll = function() {
					const e = {
						x: window.pageXOffset,
						y: window.pageYOffset,
						height: window.innerHeight,
						width: window.innerWidth
					};
					for (let t = 0; t < this.listeners.length; t++) {
						let a = this.listeners[t];
						a && this.listeners.indexOf(a) > -1 && a(e)
					}
				}, l.prototype.manageWindowEventListener = function() {
					this.listeners.length && !this.isListening ? (window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.onScroll), this.isListening = !0) : !this.listeners.length && this.isListening && (window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onScroll), this.isListening = !1)
				};
				const c = new l,
					d = function(e, t, a, n) {
						return (e /= n / 2) < 1 ? a / 2 * e * e * e * e * e + t : a / 2 * ((e -= 2) * e * e * e * e + 2) + t
					},
					m = e => {
						window.scrollTo(0, e)
					},
					u = () => window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

				function p() {
					return p = Object.assign || function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var a = arguments[t];
							for (var n in a) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n])
						}
						return e
					}, p.apply(this, arguments)
				}
				const g = n.createContext(null);
				n.PureComponent;
				const h = g.Consumer,
					v = (e, t) => a => i => n.createElement(h, null, (o => {
						let {
							store: s,
							state: r
						} = o;
						return n.createElement(a, p({}, e ? e(r, i) : {}, t ? t(s, i) : {}, i))
					}));
				var b = a(4184),
					w = a.n(b);
				const f = e => "$".concat(e / 100 % 1 == 0 ? e / 100 : (e / 100).toFixed(2)),
					E = (e, t, a) => (a = a || e + "s", 1 === t ? e : a),
					y = e => {
						let t, {
							isPending: a,
							item: i,
							updateVariantQuantity: o
						} = e;
						if (i.properties && i.properties.subscription_id) {
							const e = Number(i.properties.shipping_interval_frequency);
							let a;
							switch (i.properties.shipping_interval_unit_type) {
								case "month":
									a = E("month", e);
									break;
								case "week":
									a = E("week", e);
									break;
								case "day":
									a = E("day", e)
							}
							t = n.createElement("p", {
								className: "color--gray sans--small"
							}, "(every ", e > 1 ? e : null, " ", a, ")")
						}
						return n.createElement("div", {
							className: "media media--horizontal media--forward gutter--default"
						}, n.createElement("div", {
							className: "media__fixed cart__item__image"
						}, n.createElement("div", {
							className: "image size--1x1"
						}, n.createElement("a", {
							href: i.url,
							title: i.title
						}, n.createElement("picture", null, n.createElement("img", {
							alt: i.title,
							src: i.image
						}))))), n.createElement("div", {
							className: "media__fluid"
						}, n.createElement("div", {
							className: "media media--vertical media--reverse gutter--none cart__item__info"
						}, n.createElement("div", {
							className: "media__fluid"
						}, n.createElement("div", {
							className: "media media--horizontal media--reverse gutter--default"
						}, n.createElement("div", {
							className: "media__fluid"
						}, n.createElement("p", null, n.createElement("a", {
							href: i.url,
							title: i.title
						}, i.title)), t), n.createElement("div", {
							className: "media__fixed"
						}, n.createElement("button", {
							disabled: a,
							onClick: () => o(i.variant_id, 0),
							className: "cart__item__remove",
							title: "Remove item from cart"
						})))), n.createElement("div", {
							className: "media__fixed"
						}, n.createElement("div", {
							className: "media media--horizontal media--reverse gutter--default align--middle"
						}, n.createElement("div", {
							className: "media__fluid"
						}, n.createElement("button", {
							disabled: a,
							onClick: () => o(i.variant_id, i.quantity - 1),
							className: "cart__item__quantity-button"
						}, "-"), n.createElement("span", {
							className: w()("dib tc cart__item__quantity", {
								o50: a
							})
						}, i.quantity), n.createElement("button", {
							disabled: a,
							onClick: () => o(i.variant_id, i.quantity + 1),
							className: "cart__item__quantity-button"
						}, "+")), n.createElement("div", {
							className: "media__fixed"
						}, n.createElement("p", {
							className: "color--blue uppercase sans--xsmall fw--700"
						}, n.createElement("span", null, f(i.discounted_price * i.quantity)), i.discounted_price < i.original_price && n.createElement("span", null, " ", n.createElement("span", {
							className: "line-through color--gray"
						}, f(i.original_price * i.quantity))))))))))
					};
				var S = a(4317);
				const _ = e => {
					let t = !1;
					return s()(e.items, (e => {
						e.properties && e.properties.subscription_id && (t = !0)
					})), t
				};

				function N(e, t) {
					var a = Object.keys(e);
					if (Object.getOwnPropertySymbols) {
						var n = Object.getOwnPropertySymbols(e);
						t && (n = n.filter((function(t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						}))), a.push.apply(a, n)
					}
					return a
				}

				function k(e) {
					for (var t = 1; t < arguments.length; t++) {
						var a = null != arguments[t] ? arguments[t] : {};
						t % 2 ? N(Object(a), !0).forEach((function(t) {
							D(e, t, a[t])
						})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : N(Object(a)).forEach((function(t) {
							Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
						}))
					}
					return e
				}

				function D(e, t, a) {
					return t in e ? Object.defineProperty(e, t, {
						value: a,
						enumerable: !0,
						configurable: !0,
						writable: !0
					}) : e[t] = a, e
				}
				const O = {
						transition: "opacity ".concat(500, "ms ease-out"),
						opacity: 0
					},
					M = {
						entering: {
							opacity: 0
						},
						entered: {
							opacity: 1
						}
					},
					{
						flatRateShippingNote: L
					} = window.GLOBALS,
					{
						flatRateShippingNote: C
					} = (v((e => {
						let {
							isDesktopCartOpen: t,
							isNavigatingToCheckout: a,
							cart: n,
							pendingUpdateVariantId: i
						} = e;
						return {
							isOpen: t,
							isNavigatingToCheckout: a,
							cart: n,
							pendingUpdateVariantId: i
						}
					}), ((e, t) => {
						let {
							toggleCart: a,
							updateVariantQuantity: n,
							navigateToCheckout: i
						} = e;
						return {
							toggleCart: a,
							updateVariantQuantity: n,
							navigateToCheckout: i
						}
					}))((e => {
						let {
							isOpen: t,
							isNavigatingToCheckout: a,
							cart: i,
							pendingUpdateVariantId: o,
							toggleCart: s,
							updateVariantQuantity: r,
							navigateToCheckout: l
						} = e;
						if (!i) return null;
						const c = _(i),
							d = w()("bg--off-white cart--desktop show--lg", {
								active: t
							}),
							m = n.createElement("button", {
								onClick: s,
								title: "Close Cart",
								className: "cart--desktop__close link--dim"
							}),
							u = i.items.map(((e, t) => n.createElement("div", {
								key: t
							}, n.createElement("hr", null), n.createElement("div", {
								className: "pt4 pb4"
							}, n.createElement(y, {
								item: e,
								updateVariantQuantity: r,
								isPending: e.variant_id === o
							}))))),
							p = i.item_count ? n.createElement("div", {
								className: "media__fixed"
							}, n.createElement("hr", {
								className: "mb2"
							}), n.createElement("div", {
								className: "row mb9"
							}, n.createElement("div", {
								className: "col c6"
							}, n.createElement("p", {
								className: "color--gray sans--xsmall uppercase fw--700"
							}, "Subtotal")), n.createElement("div", {
								className: "col c6"
							}, n.createElement("p", {
								className: "color--gray tr sans--xsmall uppercase fw--700"
							}, f(i.total_price))), n.createElement("div", {
								className: "col c6"
							}, n.createElement("p", {
								className: "color--gray sans--xsmall uppercase fw--700"
							}, "Tax")), n.createElement("div", {
								className: "col c6"
							}, n.createElement("p", {
								className: "color--gray tr sans--xsmall uppercase fw--700"
							}, "TBD")), n.createElement("div", {
								className: "col"
							}, n.createElement("p", {
								className: "sans--xsmall"
							}, n.createElement("br", null)), n.createElement("p", {
								className: "color--blue tc sans--xsmall uppercase fw--700"
							}, L)))) : null,
							g = !c && n.createElement("div", {
								className: "mt2"
							}, n.createElement("div", {
								className: "row"
							}, n.createElement("div", {
								className: "col c12"
							}, n.createElement("button", {
								disabled: a,
								onClick: l,
								type: "submit",
								name: "amazon",
								title: "Checkout with Amazon Pay",
								className: w()("button--amazon full-width", {
									loading: a
								})
							})))),
							h = n.createElement("div", {
								className: w()("cart--desktop__footer bg--off-white show--lg", {
									active: t,
									"pe--none": !i.item_count,
									o0: !i.item_count
								})
							}, n.createElement("hr", null), n.createElement("div", {
								className: "p2"
							}, n.createElement("button", {
								onClick: l,
								name: "checkout",
								className: "button--primary full-width button--scale"
							}, n.createElement("span", {
								className: "button--scale__text"
							}, "Continue to Checkout")), g)),
							v = n.createElement(S.Transition, {
								in: t,
								mountOnEnter: !0,
								unmountOnExit: !0,
								appear: !0,
								timeout: {
									enter: 0,
									exit: 500
								}
							}, (e => n.createElement("div", {
								style: k(k({}, O), M[e]),
								className: "cart__underlay show--lg",
								onClick: s
							})));
						return n.createElement(n.Fragment, null, v, n.createElement("div", {
							className: d
						}, n.createElement("div", {
							className: "cart--desktop__main p2 pt8 media media--vertical gutter--none"
						}, n.createElement("div", {
							className: "media__fluid"
						}, n.createElement("div", {
							className: "mb3"
						}, m), n.createElement("h2", {
							className: "sans--small-medium color--blue mb2"
						}, i.item_count > 0 ? "Your Cart (".concat(i.item_count, ")") : "Nothing here yet!"), u), n.createElement("div", {
							className: w()({
								pb8: !c
							})
						}, p))), h)
					})), window.GLOBALS);
				v((e => {
					let {
						cart: t,
						pendingUpdateVariantId: a,
						isNavigatingToCheckout: n
					} = e;
					return {
						cart: t,
						pendingUpdateVariantId: a,
						isNavigatingToCheckout: n
					}
				}), ((e, t) => {
					let {
						updateVariantQuantity: a,
						navigateToCheckout: n,
						toggleCart: i
					} = e;
					return {
						updateVariantQuantity: a,
						navigateToCheckout: n,
						toggleCart: i
					}
				}))((e => {
					let {
						pendingUpdateVariantId: t,
						isNavigatingToCheckout: a,
						cart: i,
						updateVariantQuantity: o,
						navigateToCheckout: s,
						toggleCart: r
					} = e;
					if (!i) return null;
					const l = _(i),
						c = i.items.map(((e, a) => n.createElement("div", {
							key: a
						}, n.createElement("hr", null), n.createElement("div", {
							className: "pt2 pb2"
						}, n.createElement(y, {
							item: e,
							updateVariantQuantity: o,
							isPending: e.variant_id === t
						}))))),
						d = i.item_count ? n.createElement("div", null, n.createElement("hr", {
							className: "mb2"
						}), n.createElement("div", {
							className: "row mb2"
						}, n.createElement("div", {
							className: "col c6"
						}, n.createElement("p", {
							className: "color--gray sans--xsmall uppercase fw--700"
						}, "Subtotal")), n.createElement("div", {
							className: "col c6"
						}, n.createElement("p", {
							className: "color--gray tr sans--xsmall uppercase fw--700"
						}, f(i.total_price))), n.createElement("div", {
							className: "col c6"
						}, n.createElement("p", {
							className: "color--gray sans--xsmall uppercase fw--700"
						}, "Tax")), n.createElement("div", {
							className: "col c6"
						}, n.createElement("p", {
							className: "color--gray tr sans--xsmall uppercase fw--700"
						}, "TBD")), n.createElement("div", {
							className: "col"
						}, n.createElement("p", {
							className: "sans--xsmall"
						}, n.createElement("br", null)), n.createElement("p", {
							className: "color--blue tc sans--xsmall uppercase fw--700"
						}, C)))) : null,
						m = !l && n.createElement("div", {
							className: "mt2 mb2"
						}, n.createElement("div", {
							className: "row"
						}, n.createElement("div", {
							className: "col c12"
						}, n.createElement("button", {
							disabled: a,
							onClick: s,
							type: "submit",
							name: "amazon",
							title: "Checkout with Amazon Pay",
							className: w()("button--amazon full-width", {
								loading: a
							})
						})))),
						u = i.item_count ? n.createElement("div", {
							className: "cart--mobile__footer"
						}, n.createElement("hr", null), n.createElement("div", {
							className: "p2 pb8"
						}, n.createElement("button", {
							disabled: a,
							onClick: s,
							type: "submit",
							name: "checkout",
							className: w()("button--primary full-width", {
								loading: a
							})
						}, a ? "Checking out…" : "Continue to Checkout"), m, n.createElement("p", {
							className: "tc"
						}, n.createElement("button", {
							onClick: r,
							type: "Close Cart",
							name: "Close Cart",
							className: "sans--xsmall uppercase fw--700 underline color--blue"
						}, "Continue Shopping")))) : null,
						p = 0 === i.item_count && n.createElement("button", {
							disabled: a,
							onClick: r,
							type: "Close Cart",
							name: "Close Cart",
							className: "button--primary full-width"
						}, "Continue Shopping");
					return n.createElement("div", null, n.createElement("h2", {
						className: "sans--medium color--blue mb2 tc"
					}, i.item_count > 0 ? "Your Cart (".concat(i.item_count, ")") : "Nothing here yet!"), c, d, u, p)
				}));
				var x = a(1763),
					A = a.n(x),
					T = a(4721),
					V = a.n(T);
				const j = e => {
					let t = e.path ? e.path[0] : e.target;
					for (; t && t.matches && !t.matches("a[href]");) t = t.parentNode;
					if (!t || !t.matches || !t.matches("a[href]")) return;
					if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
					if (t.target && "_blank" === t.target) return;
					if (t.getAttribute && "string" == typeof t.getAttribute("download")) return;
					if (t.href.indexOf("#") < 0) return;
					const a = document.querySelector(t.hash);
					if (!a) return;
					e.preventDefault();
					const n = window.innerWidth >= 800 ? 60 : 50;
					! function(e) {
						let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3,
							a = arguments.length > 2 ? arguments[2] : void 0;
						const n = u(),
							i = e - n;
						let o = new Date;
						const s = function() {
							const r = new Date - o,
								l = d(r, n, i, t);
							m(l), r < t ? requestAnimationFrame(s) : (m(e), a && a())
						};
						s()
					}(a.offsetTop - n, 1e3);
					a.matches("a[href], button, input, select, textarea, [tabindex]") || a.setAttribute("tabindex", "-1"), a.focus({
						preventScroll: !0
					})
				};
				const Dd = (e, t, a) => {
					if (!e || !t) return;
					const n = () => Array.from(e.querySelectorAll("a[href]")),
						i = () => {
							const e = t.closest("li"),
								a = e && e.nextElementSibling;
							return a && a.querySelector("a[href], button, input")
						};
					t.addEventListener("click", (() => {
						t.matches(":hover") || setTimeout((() => {
							"true" === t.getAttribute("aria-expanded") && n()[0] && n()[0].focus()
						}), 50)
					})), t.addEventListener("keydown", (e => {
						"Escape" === e.key && "true" === t.getAttribute("aria-expanded") && (a(), t.setAttribute("aria-expanded", "false"))
					})), e.addEventListener("keydown", (e => {
						const o = n();
						if ("Escape" === e.key) a(), t.setAttribute("aria-expanded", "false"), t.focus();
						else if ("Tab" === e.key && o.length) {
							if (e.shiftKey && document.activeElement === o[0]) e.preventDefault(), t.focus();
							else if (!e.shiftKey && document.activeElement === o[o.length - 1]) {
								const r = i();
								r && (e.preventDefault(), a(), r.focus())
							}
						}
					}))
				};
				var q = a(3311),
					P = a.n(q),
					H = a(3632),
					I = a.n(H);
				const F = e => {
						let {
							minimumCents: t = 100,
							currentCents: a = 100
						} = e;
						const i = a / t * 100,
							o = 100 - I()([i, 100]);
						return n.createElement("div", null, n.createElement("div", {
							className: "mb1"
						}, a < t && n.createElement("span", {
							className: "dib vam cart__free-shipping-price sans--xsmall uppercase fw--700"
						}, f(t - a)), a >= t && n.createElement("span", {
							className: "dib vam cart__free-shipping-check"
						}), n.createElement("span", {
							className: "dib vam ml1 sans--xsmall uppercase color--black o80 fw--700"
						}, a >= t ? "Free shipping unlocked" : "Away from free shipping!")), n.createElement("div", {
							className: "cart__shipping-meter of--hidden"
						}, n.createElement("div", {
							className: w()("cart__shipping-indicator", {
								free: a >= t
							}),
							style: {
								transform: "translate3d(-".concat(o, "%, 0, 0)")
							}
						})))
					},
					z = e => {
						let {
							product: t,
							onAddVariant: a,
							listen: i
						} = e;
						const o = n.useRef(),
							s = t.variants[0].id;
						return i((e => {
							if (o.current)
								if (s === e.pendingAddVariantId) o.current.innerHTML = '<span class="button--scale__text">Adding…</span>', o.current.classList.add("loading"), o.current.disabled = !0;
								else if (V()(e.addedVariantIds, s)) {
								o.current.innerHTML = '<span class="button--scale__text">Added</span>', o.current.classList.remove("loading");
								const e = setTimeout((() => {
									o.current.innerHTML = '<span className="button--scale__text">Add&nbsp;&nbsp;-&nbsp;&nbsp;'.concat(f(t.price), "</span>"), o.current.disabled = !1, clearTimeout(e)
								}), 1e3)
							} else o.current.innerHTML = '<span className="button--scale__text">Add&nbsp;&nbsp;-&nbsp;&nbsp;'.concat(f(t.price), "</span>"), o.current.classList.remove("loading"), o.current.disabled = !1
						})), n.createElement("div", {
							className: "related-row__col"
						}, n.createElement("div", {
							className: "db push-up"
						}, n.createElement("span", {
							className: "db pt1 pb1"
						}, n.createElement("span", {
							className: "product-tile__img-container db pr"
						}, n.createElement("span", {
							className: "product-tile__img db image size--1x1 mb1 pl2--xl pr2--xl"
						}, n.createElement("picture", null, n.createElement("img", {
							alt: t.title,
							src: t.featured_image
						})))), n.createElement("span", {
							className: "db pl2--md pr2--md flex fcol jcc"
						}, n.createElement("a", {
							title: t.title,
							href: "/products/".concat(t.handle)
						}, n.createElement("span", {
							className: "db color--blue tc pb1"
						}, t.title)), n.createElement("button", {
							ref: o,
							onClick: e => {
								A()(s) && a && a(s, 1, {}, null)
							},
							title: "Add ".concat(t.title, " to Cart"),
							"data-quick-add": s,
							"aria-label": "Quick Add",
							name: "Quick Add",
							className: "button--secondary--small button--secondary--blue button--scale ws--nowrap"
						}, n.createElement("span", {
							className: "button--scale__text"
						}, "Add  -  ", f(t.price)))))))
					},
					B = e => {
						let {
							cart: t,
							variantId: a,
							quantity: i,
							closeModal: o,
							relatedProducts: s,
							onAddVariant: r,
							listen: l
						} = e;
						const {
							shippingMinimum: c
						} = window.GLOBALS, [d, m] = n.useState(t.total_price), u = P()(t.items, {
							variant_id: a
						});
						let p;
						if (u.properties && u.properties.subscription_id) {
							const e = Number(u.properties.shipping_interval_frequency);
							let t;
							switch (u.properties.shipping_interval_unit_type) {
								case "month":
									t = E("month", e);
									break;
								case "week":
									t = E("week", e);
									break;
								case "day":
									t = E("day", e)
							}
							p = n.createElement("p", {
								className: "color--gray sans--small"
							}, "(every ".concat(e > 1 ? e : "", " ").concat(t, ")"))
						}
						l((e => {
							e.cart.total_price !== d && m(e.cart.total_price)
						}));
						const g = n.createElement("div", {
								className: "media media--horizontal media--forward gutter--default"
							}, n.createElement("div", {
								className: "media__fixed cart__item__image"
							}, n.createElement("div", {
								className: "image size--1x1"
							}, n.createElement("picture", null, n.createElement("img", {
								alt: u.title,
								src: u.image
							})))), n.createElement("div", {
								className: "media__fluid"
							}, n.createElement("div", {
								className: "media media--vertical media--reverse gutter--none cart__item__info"
							}, n.createElement("div", {
								className: "media__fluid"
							}, n.createElement("p", null, u.title), p, n.createElement("p", {
								className: "color--blue"
							}, n.createElement("span", {
								className: "cart__item-added-check vam dib"
							}), n.createElement("span", null, " "), n.createElement("span", {
								className: "dib vam"
							}, "Added to Cart"))), n.createElement("div", {
								className: "media__fixed"
							}, n.createElement("div", {
								className: "media media--horizontal media--reverse gutter--default align--middle"
							}, n.createElement("div", {
								className: "media__fluid"
							}, n.createElement("p", {
								className: "color--gray sans--xsmall uppercase fw--700"
							}, "QTY: ", u.quantity)), n.createElement("div", {
								className: "media__fixed"
							}, n.createElement("p", {
								className: "color--blue uppercase sans--xsmall fw--700"
							}, n.createElement("span", null, f(u.discounted_price * u.quantity)), u.discounted_price < u.original_price && n.createElement("span", null, " ", n.createElement("span", {
								className: "line-through color--gray"
							}, f(u.original_price * u.quantity)))))))))),
							h = s && s.length > 0 ? n.createElement("div", {
								className: "pb1"
							}, n.createElement("h3", {
								className: "sans--small color--blue fw--700 uppercase tc mb1"
							}, "Frequently Bought With"), n.createElement("div", {
								className: "modal--cart-add__related-row"
							}, s.map((e => n.createElement(z, {
								key: e.id,
								product: e,
								listen: l,
								onAddVariant: r
							}))))) : null;
						return n.createElement("div", null, n.createElement("div", {
							className: "mb2"
						}, n.createElement(F, {
							minimumCents: c,
							currentCents: d
						})), n.createElement("div", {
							className: "mb2"
						}, g), n.createElement("div", {
							className: "row"
						}, n.createElement("div", {
							className: "col c6"
						}, n.createElement("a", {
							className: "button--primary button--scale full-width",
							href: "/cart"
						}, n.createElement("span", {
							className: "button--scale__text"
						}, "View Cart"))), n.createElement("div", {
							className: "col c6"
						}, n.createElement("button", {
							onClick: o,
							className: "full-width button--primary invert border button--scale"
						}, n.createElement("span", {
							className: "button--scale__text"
						}, n.createElement("span", {
							className: "show--md"
						}, "Continue Shopping"), n.createElement("span", {
							className: "hide--md dib",
							style: {
								lineHeight: "1em",
								marginTop: 10
							}
						}, "Continue", n.createElement("br", null), "Shopping"))))), s && n.createElement("hr", {
							className: "mt2 mb2"
						}), h)
					},
					Q = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				var R = a(1711);

				function U(e, t) {
					var a = Object.keys(e);
					if (Object.getOwnPropertySymbols) {
						var n = Object.getOwnPropertySymbols(e);
						t && (n = n.filter((function(t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						}))), a.push.apply(a, n)
					}
					return a
				}

				function Y(e, t, a) {
					return t in e ? Object.defineProperty(e, t, {
						value: a,
						enumerable: !0,
						configurable: !0,
						writable: !0
					}) : e[t] = a, e
				}
				const W = {
					isSubmitting: !1,
					formError: !1,
					formSuccess: !1,
					email: ""
				};
				class J extends n.PureComponent {
					constructor(e) {
						super(e), Y(this, "onSubmit", (e => {
							e.preventDefault(), this.setState({
								isSubmitting: !0,
								formError: !1
							}), (0, R.L)("Q5cdjt", this.state.email, {
								$fields: ["Page"],
								Page: window.location.pathname
							}).then((e => {
								e.errors.length > 0 && this.setState({
									formError: !0,
									isSubmitting: !1
								}), this.setState({
									formSuccess: !0,
									isSubmitting: !1
								})
							})).catch((e => {
								this.setState({
									formError: !0,
									isSubmitting: !1
								})
							}))
						})), Y(this, "onChangeEmail", (e => {
							this.setState({
								email: e.target.value
							})
						})), this.state = function(e) {
							for (var t = 1; t < arguments.length; t++) {
								var a = null != arguments[t] ? arguments[t] : {};
								t % 2 ? U(Object(a), !0).forEach((function(t) {
									Y(e, t, a[t])
								})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : U(Object(a)).forEach((function(t) {
									Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
								}))
							}
							return e
						}({}, W)
					}
					render() {
						const {
							isSubmitting: e,
							formSuccess: t,
							formError: a,
							email: i
						} = this.state, o = !t && n.createElement("form", {
							onSubmit: this.onSubmit,
							className: "pr form__container"
						}, n.createElement("p", {
							id: "modal-newsletter",
							className: "sr-only"
						}, "Email Address"), n.createElement("input", {
							"aria-labelledby": "modal-newsletter",
							value: i,
							onChange: this.onChangeEmail,
							className: w()("input--signup full-width", {
								error: a,
								loading: e
							}),
							type: "email",
							placeholder: "Your email address"
						}), n.createElement("button", {
							disabled: !Q.test(i) || e,
							className: w()("button--primary", {
								loading: e
							}),
							type: "submit",
							name: "Submit"
						}, "Submit")), s = t && n.createElement("p", {
							className: "input--signup__success full-width color--blue"
						}, "Success! ", n.createElement("span", {
							className: "o50"
						}, "Use CALM20 for 20% off your first order.")), r = a && n.createElement("p", {
							className: "tc uppercase fw--700 sans--xsmall mb1 color--orange mt2"
						}, "Oh no! Something went wrong.");
						return n.createElement(n.Fragment, null, o, s, r)
					}
				}

				function K(e, t) {
					var a = Object.keys(e);
					if (Object.getOwnPropertySymbols) {
						var n = Object.getOwnPropertySymbols(e);
						t && (n = n.filter((function(t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						}))), a.push.apply(a, n)
					}
					return a
				}

				function $(e, t, a) {
					return t in e ? Object.defineProperty(e, t, {
						value: a,
						enumerable: !0,
						configurable: !0,
						writable: !0
					}) : e[t] = a, e
				}
				const G = {
					isSubmitting: !1,
					formError: !1,
					formSuccess: !1,
					email: ""
				};
				class X extends n.PureComponent {
					constructor(e) {
						super(e), $(this, "onSubmit", (e => {
							e.preventDefault(), this.setState({
								isSubmitting: !0,
								formError: !1
							}), (0, R.L)("Q5cdjt", this.state.email, {
								$fields: ["Page"],
								Page: window.location.pathname
							}).then((e => {
								e.errors.length > 0 && this.setState({
									formError: !0,
									isSubmitting: !1
								}), this.setState({
									formSuccess: !0,
									isSubmitting: !1
								})
							})).catch((e => {
								this.setState({
									formError: !0,
									isSubmitting: !1
								})
							}))
						})), $(this, "onChangeEmail", (e => {
							this.setState({
								email: e.target.value
							})
						})), this.state = function(e) {
							for (var t = 1; t < arguments.length; t++) {
								var a = null != arguments[t] ? arguments[t] : {};
								t % 2 ? K(Object(a), !0).forEach((function(t) {
									$(e, t, a[t])
								})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : K(Object(a)).forEach((function(t) {
									Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
								}))
							}
							return e
						}({}, G)
					}
					render() {
						const {
							isSubmitting: e,
							formSuccess: t,
							formError: a,
							email: i
						} = this.state, o = !t && n.createElement("form", {
							onSubmit: this.onSubmit,
							className: "pr form__container"
						}, n.createElement("label", {
							className: "sr-only",
							htmlFor: "signup-newsletter"
						}, "Email Address"), n.createElement("input", {
							id: "signup-newsletter",
							value: i,
							onChange: this.onChangeEmail,
							className: w()("input--signup-footer full-width", {
								error: a,
								loading: e
							}),
							type: "email",
							placeholder: "Your email address"
						}), n.createElement("button", {
							id: "btn_signup_newsletter",
							disabled: !Q.test(i) || e,
							className: w()("uppercase color--white fw--700 sans--xsmall", {
								loading: e
							}),
							type: "submit",
							name: "Submit"
						}, "Submit")), s = t && n.createElement("p", {
							className: "tc tl--lg uppercase color--white fw--700 sans--xsmall pt1"
						}, "Success! ", n.createElement("span", {
							className: "o50"
						}, "Use CALM20 for 20% off your first order.")), r = a && n.createElement("p", {
							className: "tc tl--lg uppercase color--white fw--700 sans--xsmall pt2"
						}, n.createElement("span", {
							className: "color--orange"
						}, "Oh no!"), " Something went wrong.");
						return n.createElement(n.Fragment, null, o, s, r)
					}
				}
				const Z = e => {
					let t = !1;
					const a = () => {
						const n = e.getBoundingClientRect();
						(n.top >= 0 && n.top <= window.innerHeight + 400 || n.top <= 0 && n.bottom >= -400) && setTimeout((() => {
							e.classList.add("active"), t = !0
						}), 200), t && c.unlisten(a)
					};
					c.listen(a), a()
				};
				var ee = a(361),
					te = a.n(ee),
					ae = a(3279),
					ne = a.n(ae),
					ie = a(2569),
					oe = a.n(ie),
					se = a(3105),
					re = a.n(se),
					le = a(4061),
					ce = a.n(le),
					de = a(569),
					me = a.n(de);

				function ue(e, t) {
					var a = Object.keys(e);
					if (Object.getOwnPropertySymbols) {
						var n = Object.getOwnPropertySymbols(e);
						t && (n = n.filter((function(t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						}))), a.push.apply(a, n)
					}
					return a
				}

				function pe(e) {
					for (var t = 1; t < arguments.length; t++) {
						var a = null != arguments[t] ? arguments[t] : {};
						t % 2 ? ue(Object(a), !0).forEach((function(t) {
							ge(e, t, a[t])
						})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ue(Object(a)).forEach((function(t) {
							Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
						}))
					}
					return e
				}

				function ge(e, t, a) {
					return t in e ? Object.defineProperty(e, t, {
						value: a,
						enumerable: !0,
						configurable: !0,
						writable: !0
					}) : e[t] = a, e
				}
				const he = function(e) {
						let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
							a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
						return me().post("/cart/add.js").send(pe(pe({}, a), {}, {
							id: e,
							quantity: t
						}))
					},
					ve = e => {
						let {
							cart: t,
							shopifyDomain: a,
							customerEmail: n
						} = e, i = !1;
						if (s()(t.items, (e => {
								e.properties && e.properties.subscription_id && (i = !0)
							})), !i) return "/checkout";
						let o = "https://checkout.rechargeapps.com/r/checkout";
						return o += "?myshopify_domain=".concat(a), o += "&cart_token=".concat(t.token), n && (o += "&customer_email=".concat(n)), o
					};

				function be(e, t) {
					var a = Object.keys(e);
					if (Object.getOwnPropertySymbols) {
						var n = Object.getOwnPropertySymbols(e);
						t && (n = n.filter((function(t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						}))), a.push.apply(a, n)
					}
					return a
				}

				function we(e) {
					for (var t = 1; t < arguments.length; t++) {
						var a = null != arguments[t] ? arguments[t] : {};
						t % 2 ? be(Object(a), !0).forEach((function(t) {
							fe(e, t, a[t])
						})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : be(Object(a)).forEach((function(t) {
							Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
						}))
					}
					return e
				}

				function fe(e, t, a) {
					return t in e ? Object.defineProperty(e, t, {
						value: a,
						enumerable: !0,
						configurable: !0,
						writable: !0
					}) : e[t] = a, e
				}
				const Ee = "curist_quiz_store",
					{
						CART: ye,
						CUSTOMER_EMAIL: Se,
						SHOPIFY_DOMAIN: _e
					} = window,
					Ne = {
						shopifyDomain: _e,
						customerEmail: Se,
						cart: ye || null,
						cartAddedModalConfig: null,
						isDesktopFixedNavVisible: !1,
						isDesktopHeaderDropdownVisible: !1,
						isMobileNavScrolled: !1,
						isMobileSubNavVisible: !1,
						isDesktopCartOpen: !1,
						isNavigatingToCheckout: !1,
						pendingUpdateVariantId: null,
						pendingAddVariantId: null,
						addedVariantIds: [],
						productRecommendations: [],
						activeMobileMenu: null,
						activeModalId: null,
						quizAnswersByCondition: {
							allergies: {
								selectedSymptoms: [],
								tabletPreference: null,
								selectedSeasons: []
							}
						},
						productFormShouldSubscribe: !1,
						productFormQuantity: 1
					};
				let ke = {};
				try {
					ke = JSON.parse(localStorage.getItem(Ee))
				} catch (e) {
					console.log("[INFO]: localStorage is disabled. Cannot save store state."), ke = {}
				}
				const De = (e => {
						let t = null,
							a = e,
							n = [];
						return {
							getState: () => a,
							setState: e => {
								t = a, a = Object.assign({}, a, e), (() => {
									for (var e = 0; e < n.length; e++) {
										var i = n[e];
										i && n.indexOf(i) > -1 && i(a, t)
									}
								})()
							},
							listen: e => {
								n.indexOf(e) > -1 || n.push(e)
							},
							unlisten: e => {
								let t = n.indexOf(e);
								t > -1 && n.splice(t, 1)
							}
						}
					})(we(we({}, te()(Ne)), ke)),
					Oe = e => {
						try {
							localStorage.setItem(Ee, JSON.stringify({
								quizAnswersByCondition: e.quizAnswersByCondition
							}))
						} catch (e) {
							console.log("[INFO]: localStorage is disabled. Cannot save store state.")
						}
					};
				De.listen(ne()(Oe, 1e3, {
					leading: !0
				}));
				const Me = () => me().get("/cart.json").then((e => {
						e.ok && e.body && De.setState({
							cart: e.body
						})
					})),
					Le = {
						getState: De.getState,
						setState: De.setState,
						listen: De.listen,
						unlisten: De.unlisten,
						showDesktopFixedHeader: () => {
							De.setState({
								isDesktopFixedNavVisible: !0
							})
						},
						hideDesktopFixedHeader: () => {
							De.setState({
								isDesktopFixedNavVisible: !1
							})
						},
						showDesktopHeaderDropdown: () => {
							De.setState({
								isDesktopHeaderDropdownVisible: !0
							})
						},
						showFixedDesktopHeaderDropdown: () => {
							De.setState({
								isFixedDesktopHeaderDropdownVisible: !0
							})
						},
						hideDesktopHeaderDropdown: () => {
							De.setState({
								isDesktopHeaderDropdownVisible: !1
							})
						},
						hideFixedDesktopHeaderDropdown: () => {
							De.setState({
								isFixedDesktopHeaderDropdownVisible: !1
							})
						},
						toggleDesktopHeaderDropdown: () => {
							const e = De.getState();
							De.setState({
								isDesktopHeaderDropdownVisible: !e.isDesktopHeaderDropdownVisible
							})
						},
						toggleFixedDesktopHeaderDropdown: () => {
							const e = De.getState();
							De.setState({
								isFixedDesktopHeaderDropdownVisible: !e.isFixedDesktopHeaderDropdownVisible
							})
						},
						openMobileMenu: e => {
							const t = "cart" === e;
							De.setState({
								activeMobileMenu: e,
								isDesktopCartOpen: t
							}), t && history && history.pushState ? history.pushState({}, window.location.title, "".concat(window.location.pathname, "?cart=open").concat(window.location.hash)) : history.pushState({}, window.location.title, "".concat(window.location.pathname).concat(window.location.hash))
						},
						closeMobileMenu: () => {
							De.setState({
								activeMobileMenu: null,
								activeModalId: null
							})
						},
						fixMobileNav: () => {
							De.setState({
								isMobileNavScrolled: !0
							})
						},
						unfixMobileNav: () => {
							De.setState({
								isMobileNavScrolled: !1
							})
						},
						showMobileSubNav: () => {
							De.setState({
								isMobileSubNavVisible: !0
							})
						},
						hideMobileSubNav: () => {
							De.setState({
								isMobileSubNavVisible: !1
							})
						},
						toggleQuizConditionSymptom: (e, t) => {
							const a = De.getState(),
								n = a.quizAnswersByCondition[e];
							let i = [...n.selectedSymptoms];
							i = V()(i, t) ? oe()(i, t) : [...i, t], De.setState(we(we({}, a), {}, {
								quizAnswersByCondition: we(we({}, a.quizAnswersByCondition), {}, {
									[e]: we(we({}, n), {}, {
										selectedSymptoms: i
									})
								})
							}))
						},
						setAllergyTabletPreference: e => {
							const t = De.getState();
							De.setState(we(we({}, t), {}, {
								quizAnswersByCondition: we(we({}, t.quizAnswersByCondition), {}, {
									allergies: we(we({}, t.quizAnswersByCondition.allergies), {}, {
										tabletPreference: e
									})
								})
							}))
						},
						toggleAllergySeason: e => {
							const t = De.getState(),
								a = t.quizAnswersByCondition.allergies;
							let n = [...a.selectedSeasons];
							n = V()(n, e) ? oe()(n, e) : [...n, e], De.setState(we(we({}, t), {}, {
								quizAnswersByCondition: we(we({}, t.quizAnswersByCondition), {}, {
									allergies: we(we({}, a), {}, {
										selectedSeasons: n
									})
								})
							}))
						},
						openModal: e => {
							De.setState({
								activeModalId: e,
								activeMobileMenu: e
							})
						},
						closeModal: () => {
							De.setState({
								activeModalId: null,
								activeMobileMenu: null
							})
						},
						closeAddModal: () => {
							De.setState({
								cartAddedModalConfig: null
							})
						},
						openCart: function() {
							let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
							De.setState({
								isDesktopCartOpen: !0,
								activeMobileMenu: "cart"
							}), e && history.pushState({}, window.location.title, "".concat(window.location.pathname, "?cart=open").concat(window.location.hash))
						},
						toggleCart: () => {
							const {
								isDesktopCartOpen: e,
								activeMobileMenu: t
							} = De.getState();
							e || "cart" === t ? (De.setState({
								isDesktopCartOpen: !1,
								activeMobileMenu: null,
								activeModalId: null
							}), history.pushState({}, window.location.title, "".concat(window.location.pathname).concat(window.location.hash))) : (De.setState({
								isDesktopCartOpen: !0,
								activeMobileMenu: "cart"
							}), history.pushState({}, window.location.title, "".concat(window.location.pathname, "?cart=open").concat(window.location.hash)))
						},
						closeCart: function() {
							let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
							De.setState({
								isDesktopCartOpen: !1,
								activeMobileMenu: null,
								activeModalId: null
							}), e && history.pushState({}, window.location.title, "".concat(window.location.pathname).concat(window.location.hash))
						},
						fetchCart: Me,
						fetchProductRecommendations: (e, t) => function(e) {
							let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3;
							return me().get("/recommendations/products.json?product_id=".concat(e, "&limit=").concat(t))
						}(e, t).then((e => {
							e.ok && e.body.products && De.setState({
								productRecommendations: e.body.products
							})
						})).catch((() => {
							console.error("Unable to fetch product recommendations."), De.setState({
								productRecommendations: []
							})
						})),
						updateVariantQuantity: (e, t) => {
							De.setState({
								pendingUpdateVariantId: e
							}), ((e, t) => me().post("/cart/update.js").send({
								updates: {
									[e]: t
								}
							}))(e, t).then((e => {
								const t = JSON.parse(e.text);
								De.setState({
									pendingUpdateVariantId: null,
									cart: t
								})
							})).catch((e => {
								console.error(e), De.setState({
									pendingUpdateVariantId: null
								})
							}))
						},
						addVariant: function(e) {
							let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
								a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
							De.setState({
								pendingAddVariantId: e
							}), he(e, t, a).then((a => {
								const {
									cart: n,
									addedVariantIds: i
								} = De.getState(), o = [JSON.parse(a.text), ...re()(n.items, (t => t.id !== e))], s = n.item_count + t, r = ce()(o, ((e, t) => e + (t.line_price || 0)), 0), l = {
									pendingAddVariantId: null,
									addedVariantIds: [...i, e],
									cart: we(we({}, n), {}, {
										items: o,
										item_count: s,
										total_price: r
									})
								};
								De.setState(l)
							})).catch((e => {
								console.error(e), De.setState({
									pendingAddVariantId: null
								})
							}))
						},
						addVariantAndOpenCart: function(e) {
							let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
								a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
							De.setState({
								pendingAddVariantId: e
							}), he(e, t, a).then((a => {
								const {
									cart: n,
									addedVariantIds: i
								} = De.getState(), o = [JSON.parse(a.text), ...re()(n.items, (t => t.id !== e))], s = n.item_count + t, r = ce()(o, ((e, t) => e + (t.line_price || 0)), 0);
								De.setState({
									pendingAddVariantId: null,
									isDesktopCartOpen: !0,
									activeMobileMenu: "cart",
									addedVariantIds: [...i, e],
									cart: we(we({}, n), {}, {
										items: o,
										item_count: s,
										total_price: r
									})
								}), history.pushState({}, window.location.title, "".concat(window.location.pathname, "?cart=open").concat(window.location.hash))
							})).catch((e => {
								console.error(e), De.setState({
									pendingAddVariantId: null
								})
							}))
						},
						addVariantAndOpenAddedModal: function(e) {
							let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
								a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
								n = arguments.length > 3 ? arguments[3] : void 0;
							De.setState({
								pendingAddVariantId: e
							}), he(e, t, a).then((a => {
								const {
									cart: i,
									addedVariantIds: o
								} = De.getState(), s = [JSON.parse(a.text), ...re()(i.items, (t => t.id !== e))], r = i.item_count + t, l = ce()(s, ((e, t) => e + (t.line_price || 0)), 0), c = {
									pendingAddVariantId: null,
									addedVariantIds: [...o, e],
									cart: we(we({}, i), {}, {
										items: s,
										item_count: r,
										total_price: l
									})
								};
								null !== n && (c.cartAddedModalConfig = n), De.setState(c)
							})).catch((e => {
								console.error(e), De.setState({
									pendingAddVariantId: null
								})
							}))
						},
						addVariantAndCheckout: function(e) {
							let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
								a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
							De.setState({
								pendingAddVariantId: e
							}), he(e, t, a).then((a => {
								const {
									cart: n,
									addedVariantIds: i
								} = De.getState(), o = JSON.parse(a.text), s = [...re()(n.items, (t => t.id !== e)), o], r = n.item_count + t, l = ce()(s, ((e, t) => e + (t.line_price || 0)), 0);
								De.setState({
									pendingAddVariantId: null,
									isNavigatingToCheckout: !0,
									activeMobileMenu: "cart",
									addedVariantIds: [...i, e],
									cart: we(we({}, n), {}, {
										items: s,
										item_count: r,
										total_price: l
									})
								});
								const {
									shopifyDomain: c,
									customerEmail: d,
									cart: m
								} = De.getState(), u = ve({
									cart: m,
									shopifyDomain: c,
									customerEmail: d
								});
								window.location = u
							})).catch((e => {
								console.error(e), De.setState({
									pendingAddVariantId: null
								})
							}))
						},
						navigateToCheckout: () => {
							De.setState({
								isNavigatingToCheckout: !0
							}), Me().then((() => {
								const {
									shopifyDomain: e,
									customerEmail: t,
									cart: a
								} = De.getState(), n = ve({
									cart: a,
									shopifyDomain: e,
									customerEmail: t
								});
								window.location = n
							}))
						},
						clearQuizAnswers: () => {
							De.setState({
								quizAnswersByCondition: te()(Ne.quizAnswersByCondition)
							}), Oe(De.getState())
						},
						setProductFormShouldSubscribe: e => {
							De.setState({
								productFormShouldSubscribe: e
							})
						},
						setProductFormQuantity: e => {
							De.setState({
								productFormQuantity: e
							})
						}
					};
				window.STORE = Le;
				const Ce = document.querySelectorAll(".lazy-picture"),
					xe = document.querySelectorAll(".reveal__container"),
					Ae = document.querySelectorAll('a[href^="#"]'),
					Te = document.querySelectorAll(".trigger-clear-quiz"),
					Ve = document.querySelector(".header--fixed"),
					je = document.querySelector(".header--dropdown"),
					qe = document.querySelector(".header--dropdown-fixed"),
					Pe = document.querySelector("#header-dropdown-trigger"),
					He = document.querySelector("#fixed-header-dropdown-trigger"),
					Ie = document.querySelector("#fixed-header-waypoint"),
					Fe = document.querySelector(".header--mobile"),
					ze = document.querySelector(".header--mobile__trigger"),
					Be = document.querySelector(".header--mobile__takeover"),
					Qe = document.querySelector(".header--mobile__bar .header__cart-trigger"),
					Re = document.querySelectorAll(".trigger--email-capture"),
					Ue = document.querySelector(".modal--email-capture"),
					Ye = document.querySelector(".header--mobile__takeover__pane--email-capture"),
					We = document.querySelectorAll(".trigger--close-email-modal"),
					Je = document.querySelector(".modal__backdrop--desktop"),
					Ke = document.querySelector(".modal--email-capture"),
					$e = document.querySelectorAll(".trigger--customer-satisfaction"),
					Ge = document.querySelectorAll(".trigger--close-customer-satisfaction"),
					Xe = document.querySelector(".modal--customer-satisfaction"),
					Ze = document.querySelectorAll(".header__cart-trigger"),
					et = (document.getElementById("mount-desktop-cart"), document.getElementById("mount-mobile-cart"), document.querySelector(".modal--cart-add")),
					tt = document.querySelectorAll(".product-tile"),
					at = document.getElementById("mount-footer-signup"),
					nt = document.querySelectorAll(".mount-modal-signup");
				s()(Ce, (e => {
					let t = !1,
						a = !1;
					const n = e.querySelectorAll("source[data-srcset]"),
						i = e.querySelectorAll("img[data-src]"),
						o = () => {
							const r = e.getBoundingClientRect();
							0 === r.top && 0 === r.bottom && 0 === r.left && 0 === r.right && 0 === r.height && 0 === r.width && 0 === r.x && 0 === r.y || ((r.top >= 0 && r.top <= window.innerHeight + 400 || r.top <= 0 && r.bottom >= -400) && (s()(n, (e => {
								e.setAttribute("srcset", e.dataset.srcset)
							})), s()(i, (e => {
								e.setAttribute("src", e.dataset.src)
							})), e.classList.add("loading"), t = !0), (r.top >= 0 && r.top <= window.innerHeight + 400 || r.top <= 0 && r.bottom >= -400) && setTimeout((() => {
								e.classList.add("loaded"), a = !0
							}), 200), t && a && c.unlisten(o))
						};
					c.listen(o), o()
				})), setTimeout((() => {
					setTimeout((() => {
						document.documentElement.classList.remove("disable-transitions"), s()(xe, Z)
					}))
				})), je && (e => {
					let t, {
						dropdownEl: a,
						headerDropdownTrigger: n,
						listen: i,
						hideDesktopHeaderDropdown: o
					} = e;
					const r = a.querySelectorAll("a");
					s()(r, (e => {
						e.addEventListener("click", (() => {
							o();
							const t = setTimeout((() => {
								window.location.href = e.href, clearTimeout(t)
							}), 300)
						}))
					}));
					const l = () => {
						window.scrollY >= 200 && o()
					};
					Dd(a, n, o), window.addEventListener("resize", (() => {
						window.innerWidth <= 1e3 && o()
					})), i(((e, i) => {
						e.isDesktopHeaderDropdownVisible !== i.isDesktopHeaderDropdownVisible && (n.setAttribute("aria-expanded", e.isDesktopHeaderDropdownVisible ? "true" : "false"), e.isDesktopHeaderDropdownVisible ? (clearTimeout(t), a.style.display = null, setTimeout((() => {
							a.classList.add("active")
						}), 10), n.classList.add("active")) : (a.classList.remove("active"), t = setTimeout((() => {
							a.style.display = "none"
						}), 500), n.classList.remove("active")))
					})), c.listen(l), l()
				})({
					dropdownEl: je,
					headerDropdownTrigger: Pe,
					listen: Le.listen,
					hideDesktopHeaderDropdown: Le.hideDesktopHeaderDropdown
				}), qe && (e => {
					let t, {
						dropdownEl: a,
						headerDropdownTrigger: n,
						listen: i,
						hideFixedDesktopHeaderDropdown: o
					} = e;
					const r = a.querySelectorAll("a");
					s()(r, (e => {
						e.addEventListener("click", (() => {
							o();
							const t = setTimeout((() => {
								window.location.href = e.href, clearTimeout(t)
							}), 300)
						}))
					}));
					const l = () => {
						window.scrollY <= 200 && o()
					};
					Dd(a, n, o), window.addEventListener("resize", (() => {
						window.innerWidth <= 1e3 && o()
					})), i(((e, i) => {
						e.isFixedDesktopHeaderDropdownVisible !== i.isFixedDesktopHeaderDropdownVisible && (n.setAttribute("aria-expanded", e.isFixedDesktopHeaderDropdownVisible ? "true" : "false"), e.isFixedDesktopHeaderDropdownVisible ? (clearTimeout(t), a.style.display = null, setTimeout((() => {
							a.classList.add("active")
						}), 10), n.classList.add("active")) : (a.classList.remove("active"), t = setTimeout((() => {
							a.style.display = "none"
						}), 500), n.classList.remove("active")))
					})), c.listen(l), l()
				})({
					dropdownEl: qe,
					headerDropdownTrigger: He,
					listen: Le.listen,
					hideFixedDesktopHeaderDropdown: Le.hideFixedDesktopHeaderDropdown
				}), Ve && (e => {
					let t, {
						headerEl: a,
						waypointEl: n,
						listen: i,
						dropdownEl: o,
						fixedDropdownEl: s,
						showDesktopFixedHeader: r,
						hideDesktopFixedHeader: l,
						headerDropdownTrigger: d,
						showDesktopHeaderDropdown: m,
						hideDesktopHeaderDropdown: u,
						toggleDesktopHeaderDropdown: p,
						fixedHeaderDropdownTrigger: g,
						showFixedDesktopHeaderDropdown: h,
						hideFixedDesktopHeaderDropdown: v,
						toggleFixedDesktopHeaderDropdown: b
					} = e;
					const w = () => {
						(n ? n.getBoundingClientRect().top : 0) <= 0 ? r() : (l(), v())
					};
					d && (d.addEventListener("click", (function() {
						this.classList.contains("active") ? this.classList.remove("active") : this.classList.add("active"), p()
					})), d.addEventListener("mouseenter", (function() {
						this.classList.contains("active") ? this.classList.remove("active") : this.classList.add("active"), m()
					}))), g && (g.addEventListener("click", (function() {
						this.classList.contains("active") ? this.classList.remove("active") : this.classList.add("active"), b()
					})), g.addEventListener("mouseenter", (function() {
						this.classList.contains("active") ? this.classList.remove("active") : this.classList.add("active"), h()
					}))), o && o.addEventListener("mouseleave", (function() {
						u()
					})), s && s.addEventListener("mouseleave", (function() {
						v()
					})), i(((e, n) => {
						e.isDesktopFixedNavVisible !== n.isDesktopFixedNavVisible && (e.isDesktopFixedNavVisible ? (clearTimeout(t), a.style.display = null, setTimeout((() => {
							a.classList.add("active")
						}), 10)) : (a.classList.remove("active"), t = setTimeout((() => {
							a.style.display = "none"
						}), 500)))
					})), c.listen(w), w()
				})({
					headerEl: Ve,
					waypointEl: Ie,
					listen: Le.listen,
					dropdownEl: je,
					fixedDropdownEl: qe,
					showDesktopFixedHeader: Le.showDesktopFixedHeader,
					hideDesktopFixedHeader: Le.hideDesktopFixedHeader,
					headerDropdownTrigger: Pe,
					fixedHeaderDropdownTrigger: He,
					showDesktopHeaderDropdown: Le.showDesktopHeaderDropdown,
					hideDesktopHeaderDropdown: Le.hideDesktopHeaderDropdown,
					toggleDesktopHeaderDropdown: Le.toggleDesktopHeaderDropdown,
					showFixedDesktopHeaderDropdown: Le.showFixedDesktopHeaderDropdown,
					hideFixedDesktopHeaderDropdown: Le.hideFixedDesktopHeaderDropdown,
					toggleFixedDesktopHeaderDropdown: Le.toggleFixedDesktopHeaderDropdown
				}), Fe && (e => {
					let t, {
						menuTriggerEl: a,
						cartTriggerEl: n,
						waypointEl: i,
						navEl: o,
						takeoverEl: r,
						listen: l,
						getState: d,
						openMobileMenu: m,
						closeMobileMenu: p,
						fixMobileNav: g,
						unfixMobileNav: h,
						showMobileSubNav: v,
						hideMobileSubNav: b
					} = e;
					const w = document.querySelectorAll(".header--mobile__nested");
					s()(w, (e => {
						const t = e.querySelector("button");
						t.addEventListener("click", (() => {
							e.classList.contains("active") ? e.classList.remove("active") : e.classList.add("active"), t.setAttribute("aria-expanded", e.classList.contains("active") ? "true" : "false")
						}))
					})), a.addEventListener("click", (() => {
						const {
							activeMobileMenu: e
						} = d();
						"menu" === e || "email-capture" === e ? p() : m("menu")
					})), document.addEventListener("keydown", (e => {
						"Escape" === e.key && d().activeMobileMenu && (p(), a.setAttribute("aria-expanded", "false"), a.focus())
					}));
					const y = [document.getElementById("main-content"), document.querySelector("footer")];
					const f = () => {
						const e = u();
						(i ? i.getBoundingClientRect().top : 0) <= 0 ? v() : b(), e > 0 ? g() : h()
					};
					const T = a;
					l(((e, a) => {
						if (e.activeMobileMenu !== a.activeMobileMenu && (T.setAttribute("aria-expanded", "menu" === e.activeMobileMenu ? "true" : "false"), y.forEach((t => {
								t && (t.inert = !!e.activeMobileMenu)
							})), "menu" === e.activeMobileMenu && !T.matches(":hover") && setTimeout((() => {
								const e = r.querySelector(".header--mobile__takeover__pane--menu button, .header--mobile__takeover__pane--menu a[href]");
								e && e.focus()
							}), 50), !e.activeMobileMenu && r.contains(document.activeElement) && T.focus()), e.activeMobileMenu !== a.activeMobileMenu) {
							if (e.activeMobileMenu && a.activeMobileMenu) return o.classList.remove("active-pane--menu"), o.classList.remove("active-pane--cart"), o.classList.remove("active-pane--email-capture"), void o.classList.add("active-pane--".concat(e.activeMobileMenu));
							o.classList.remove("active-pane--menu"), o.classList.remove("active-pane--cart"), o.classList.remove("active-pane--email-capture"), clearTimeout(t), e.activeMobileMenu ? (r.style.display = null, t = setTimeout((() => {
								o.classList.add("active-pane--".concat(e.activeMobileMenu))
							}), 10)) : t = setTimeout((() => {
								r.style.display = "none"
							}), 500), "cart" === e.activeMobileMenu ? n.classList.add("cart-open") : n.classList.remove("cart-open")
						}
						e.isMobileNavScrolled !== a.isMobileNavScrolled && (e.isMobileNavScrolled ? o.classList.add("scrolled") : o.classList.remove("scrolled")), e.isMobileSubNavVisible !== a.isMobileSubNavVisible && (e.isMobileSubNavVisible ? o.classList.add("scrolled--subnav") : o.classList.remove("scrolled--subnav"))
					})), c.listen(f), f()
				})({
					listen: Le.listen,
					openMobileMenu: Le.openMobileMenu,
					closeMobileMenu: Le.closeMobileMenu,
					waypointEl: Ie,
					navEl: Fe,
					menuTriggerEl: ze,
					takeoverEl: Be,
					cartTriggerEl: Qe,
					getState: Le.getState,
					fixMobileNav: Le.fixMobileNav,
					unfixMobileNav: Le.unfixMobileNav,
					showMobileSubNav: Le.showMobileSubNav,
					hideMobileSubNav: Le.hideMobileSubNav
				}), Ze && (e => {
					let {
						cartTriggerEls: t,
						store: a
					} = e;
					a.listen(((e, a) => {
						e.cart && a.cart && e.cart.item_count !== a.cart.item_count && s()(t, (a => {
							console.log(t), a.innerHTML = e.cart.item_count, a.setAttribute("aria-label", "Cart, ".concat(e.cart.item_count, 1 === e.cart.item_count ? " item" : " items")), e.cart.item_count > 0 ? a.classList.add("active") : a.classList.remove("active")
						}))
					}))
				})({
					store: Le,
					cartTriggerEls: Ze
				}), et && (e => {
					let t, {
						el: a,
						store: o,
						closeModal: s,
						backdropEl: r
					} = e;
					const l = a.querySelector(".modal--cart-add__close"),
						c = a.querySelector("#mount-cart-add"),
						d = a.querySelector("h2");
					let u, m;
					document.addEventListener("focusin", (e => {
						a.contains(e.target) || (m = e.target)
					})), a.addEventListener("keydown", (e => {
						if ("Tab" !== e.key) return;
						const t = Array.from(a.querySelectorAll("a[href], button:not([disabled]), input, select, textarea")).filter((e => e.offsetWidth || e.offsetHeight));
						if (!t.length) return;
						const n = t[0],
							i = t[t.length - 1];
						e.shiftKey && (document.activeElement === n || document.activeElement === d) ? (e.preventDefault(), i.focus()) : e.shiftKey || document.activeElement !== i || (e.preventDefault(), n.focus())
					})), l.addEventListener("click", s), r.addEventListener("click", s), window.addEventListener("keyup", (e => {
						27 === e.keyCode && s()
					})), o.listen(((e, l) => {
						e.cartAddedModalConfig !== l.cartAddedModalConfig && (e.cartAddedModalConfig ? (u = m, setTimeout((() => {
							d && d.focus()
						}), 60)) : u && document.body.contains(u) && (u.focus(), u = null)), e.cartAddedModalConfig !== l.cartAddedModalConfig && (clearTimeout(t), e.cartAddedModalConfig ? (a.classList.remove("dn"), r.classList.remove("dn"), i.render(n.createElement(B, {
							closeModal: s,
							cart: e.cart,
							variantId: e.cartAddedModalConfig.variantId,
							quantity: e.cartAddedModalConfig.quantity,
							relatedProducts: e.cartAddedModalConfig.relatedProducts,
							listen: o.listen,
							onAddVariant: o.addVariantAndOpenAddedModal
						}), c), t = setTimeout((() => {
							a.classList.add("active"), r.classList.add("active")
						}), 50)) : (a.classList.remove("active"), r.classList.remove("active"), t = setTimeout((() => {
							a.classList.add("dn"), r.classList.add("dn")
						}), 500)))
					}))
				})({
					store: Le,
					el: et,
					closeModal: Le.closeAddModal,
					backdropEl: Je
				}), Xe && (e => {
					let t, {
						openTriggerEls: a,
						modalId: n,
						desktopModalEl: i,
						closeEls: o,
						backdropEl: r,
						closeModal: l,
						openModal: c,
						listen: d
					} = e;
					const m = () => c(n);
					s()(a, (e => {
						e.addEventListener("click", m)
					})), s()(o, (e => {
						e.addEventListener("click", l)
					})), r.addEventListener("click", l), window.addEventListener("keyup", (e => {
						27 === e.keyCode && l()
					})), d(((e, a) => {
						e.activeModalId !== a.activeModalId && (clearTimeout(t), e.activeModalId ? (r.classList.remove("dn"), t = setTimeout((() => {
							r.classList.add("active")
						}), 50)) : (r.classList.remove("active"), t = setTimeout((() => {
							r.classList.add("dn")
						}), 500)), e.activeModalId === n ? (i.classList.remove("dn"), t = setTimeout((() => {
							i.classList.add("active")
						}), 50)) : (i.classList.remove("active"), t = setTimeout((() => {
							i.classList.add("dn")
						}), 500)))
					}))
				})({
					openTriggerEls: $e,
					desktopModalEl: Xe,
					closeEls: Ge,
					backdropEl: Je,
					modalId: "customer-satisfaction",
					closeModal: Le.closeModal,
					openModal: Le.openModal,
					listen: Le.listen
				}), Ue && Ye && (e => {
					let t, {
						openTriggerEls: a,
						modalId: n,
						desktopModalEl: i,
						mobileModalEl: o,
						closeEls: r,
						backdropEl: l,
						closeModal: c,
						openModal: d,
						listen: m
					} = e;
					const u = () => d(n);
					s()(a, (e => {
						e.addEventListener("click", u)
					})), s()(r, (e => {
						e.addEventListener("click", c)
					})), l.addEventListener("click", c), window.addEventListener("keyup", (e => {
						27 === e.keyCode && c()
					})), m(((e, a) => {
						e.activeModalId !== a.activeModalId && (clearTimeout(t), e.activeModalId ? (l.classList.remove("dn"), t = setTimeout((() => {
							l.classList.add("active")
						}), 50)) : (l.classList.remove("active"), t = setTimeout((() => {
							l.classList.add("dn")
						}), 500)), e.activeModalId === n ? (i.classList.remove("dn"), o.classList.remove("dn"), t = setTimeout((() => {
							i.classList.add("active"), o.classList.add("active")
						}), 50)) : (i.classList.remove("active"), o.classList.remove("active"), t = setTimeout((() => {
							i.classList.add("dn"), o.classList.add("dn")
						}), 500)))
					}))
				})({
					openTriggerEls: Re,
					desktopModalEl: Ue,
					mobileModalEl: Ye,
					closeEls: We,
					backdropEl: Je,
					modalId: "email-capture",
					closeModal: Le.closeModal,
					openModal: Le.openModal,
					listen: Le.listen
				}), (e => {
					let {
						anchorEls: t
					} = e;
					s()(t, (e => {
						e.addEventListener("click", j)
					}))
				})({
					anchorEls: Ae
				}), s()(Te, (e => {
					e.addEventListener("click", (t => {
						window.STORE && (t.preventDefault(), window.STORE.clearQuizAnswers(), setTimeout((() => {
							window.location = e.getAttribute("href")
						}), 50))
					}))
				})), s()(tt, (e => {
					(e => {
						let {
							el: t,
							listen: a,
							onAddVariant: n
						} = e
					})({
						el: e,
						listen: Le.listen,
						onAddVariant: Le.addVariantAndOpenAddedModal
					})
				}));
				const it = () => {
					Ke.classList.add("success")
				};
				s()(nt, (e => {
					(0, i.render)(n.createElement(J, {
						onSuccess: it
					}), e)
				})), at && (0, i.render)(n.createElement(X, null), at), Le.fetchCart();
				const ot = () => {
					const {
						isDesktopCartOpen: e
					} = Le.getState();
					window.location.search.indexOf("cart=open") > -1 && !e ? Le.openCart(!1) : -1 === window.location.search.indexOf("cart=open") && e && Le.closeCart(!1)
				};
				window.onpopstate = ot, ot(), Le.listen((e => {
					e.isDesktopCartOpen || e.activeMobileMenu || e.activeModalId ? document.documentElement.classList.add("no-scroll") : document.documentElement.classList.remove("no-scroll")
				}));
				const st = document.querySelectorAll("a, button");
				var rt, lt;
				s()(st, (e => {
					e.addEventListener("mouseup", (() => {
						e.matches(":hover") && e.blur()
					}))
				})), lt = !1, document.body.addEventListener("touchstart", (function(e) {
					e.target.closest(".flickity-slider") ? (lt = !0, rt = {
						x: e.touches[0].pageX,
						y: e.touches[0].pageY
					}) : lt = !1
				})), document.body.addEventListener("touchmove", (function(e) {
					if (lt && e.cancelable) {
						var t = {
							x: e.touches[0].pageX - rt.x,
							y: e.touches[0].pageY - rt.y
						};
						Math.abs(t.x) > 7 && e.preventDefault()
					}
				}), {
					passive: !1
				}), console.log("\nSite Credit\n===========\nNaming, Branding, Creative Direction : https://hightidenyc.com/\nDesign : https://alright.studio\nDevelopment : https://gardener.nyc | https://www.avc.dev\n")
			}
		},
		a = {};

	function n(e) {
		var i = a[e];
		if (void 0 !== i) return i.exports;
		var o = a[e] = {
			id: e,
			loaded: !1,
			exports: {}
		};
		return t[e].call(o.exports, o, o.exports, n), o.loaded = !0, o.exports
	}
	n.m = t, e = [], n.O = (t, a, i, o) => {
		if (!a) {
			var s = 1 / 0;
			for (d = 0; d < e.length; d++) {
				for (var [a, i, o] = e[d], r = !0, l = 0; l < a.length; l++)(!1 & o || s >= o) && Object.keys(n.O).every((e => n.O[e](a[l]))) ? a.splice(l--, 1) : (r = !1, o < s && (s = o));
				if (r) {
					e.splice(d--, 1);
					var c = i();
					void 0 !== c && (t = c)
				}
			}
			return t
		}
		o = o || 0;
		for (var d = e.length; d > 0 && e[d - 1][2] > o; d--) e[d] = e[d - 1];
		e[d] = [a, i, o]
	}, n.n = e => {
		var t = e && e.__esModule ? () => e.default : () => e;
		return n.d(t, {
			a: t
		}), t
	}, n.d = (e, t) => {
		for (var a in t) n.o(t, a) && !n.o(e, a) && Object.defineProperty(e, a, {
			enumerable: !0,
			get: t[a]
		})
	}, n.g = function() {
		if ("object" == typeof globalThis) return globalThis;
		try {
			return this || new Function("return this")()
		} catch (e) {
			if ("object" == typeof window) return window
		}
	}(), n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
		"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
			value: "Module"
		}), Object.defineProperty(e, "__esModule", {
			value: !0
		})
	}, n.nmd = e => (e.paths = [], e.children || (e.children = []), e), (() => {
		var e = {
			233: 0
		};
		n.O.j = t => 0 === e[t];
		var t = (t, a) => {
				var i, o, [s, r, l] = a,
					c = 0;
				if (s.some((t => 0 !== e[t]))) {
					for (i in r) n.o(r, i) && (n.m[i] = r[i]);
					if (l) var d = l(n)
				}
				for (t && t(a); c < s.length; c++) o = s[c], n.o(e, o) && e[o] && e[o][0](), e[s[c]] = 0;
				return n.O(d)
			},
			a = self.webpackChunkcurist = self.webpackChunkcurist || [];
		a.forEach(t.bind(null, 0)), a.push = t.bind(null, a.push.bind(a))
	})();
	var i = n.O(void 0, [644], (() => n(129)));
	i = n.O(i)
})();
